import { Button, Divider, Form, Input, Select, Space } from "antd";

const { Option } = Select;

export function AddEditUserForm({ loading, form, onSubmit, onClose }) {
  return (
    <Form form={form} layout="vertical" onFinish={onSubmit} autoComplete="off">
      <Form.Item
        label="Tên"
        name="name"
        rules={[
          { required: true, message: "Vui lòng nhập tên!" },
          { min: 2, max: 50, message: "Tên phải từ 2 đến 50 ký tự!" },
        ]}
      >
        <Input size="large" placeholder="Nhập tên" />
      </Form.Item>

      <Form.Item label="Pháp danh" name="buddhistName">
        <Input size="large" placeholder="Nhập pháp danh" />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "Vui lòng nhập email!" },
          { type: "email", message: "Email không hợp lệ!" },
        ]}
      >
        <Input size="large" placeholder="Nhập email" />
      </Form.Item>

      <Form.Item
        label="Giới tính"
        name="gender"
        rules={[{ required: true, message: "Vui lòng chọn giới tính!" }]}
      >
        <Select size="large" placeholder="Chọn giới tính">
          <Option value="male">Nam</Option>
          <Option value="female">Nữ</Option>
          <Option value="other">Khác</Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="Vai trò"
        name="role"
        rules={[{ required: true, message: "Vui lòng chọn vai trò!" }]}
      >
        <Select size="large" placeholder="Chọn vai trò">
          <Option value="staff">Cộng tác viên</Option>
          <Option value="user">Thành Viên</Option>
          <Option value="assistant">Trợ lý sự kiện</Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="Số điện thoại"
        name="phone"
        rules={[
          { required: true, message: "Vui lòng nhập số điện thoại!" },
          { pattern: /^\d{10,15}$/, message: "Số điện thoại không hợp lệ!" },
        ]}
      >
        <Input size="large" placeholder="Nhập số điện thoại" />
      </Form.Item>

      <Form.Item label="Xác thực Email" name="isVerified">
        <Select
          defaultValue={false}
          size="large"
          placeholder="Chọn trạng thái xác thực"
        >
          <Option value={true}>Đã xác thực</Option>
          <Option value={false}>Chưa xác thực</Option>
        </Select>
      </Form.Item>

      <Form.Item size="large" label="Địa chỉ" name="address">
        <Input.TextArea rows={2} placeholder="Nhập địa chỉ" />
      </Form.Item>

      <Divider />

      <Form.Item>
        <Space style={{ justifyContent: "flex-end", width: "100%" }}>
          <Button
            size="large"
            variant="outlined"
            loading={loading}
            block
            onClick={onClose}
          >
            Hủy
          </Button>
          <Button
            size="large"
            type="primary"
            htmlType="submit"
            loading={loading}
            block
          >
            Lưu
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
